import axiosPrivateInstance from './AxiosPrivateInstance';

export const getAllUpcomingReservations = async () => {
    try {
        const res = await axiosPrivateInstance.get(
            '/restaurant-upcoming-reservations/'
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};
export const filterReservationList = async (
    status = '',
    page = 1,
    pageSize = 10
) => {
    try {
        // Build query parameters
        const params = new URLSearchParams({
            pageitems: pageSize.toString(),
            page: page.toString(),
        });

        // Add status filter only if it's not empty (for 'all' case, don't include status)
        if (status && status !== 'all') {
            params.append('status', status);
        }

        const res = await axiosPrivateInstance.get(
            `restaurant-table-reservation-history/?${params.toString()}`
        );

        // Return the entire response structure to maintain pagination info
        return res.data;
    } catch (error) {
        console.error('Error filtering reservation list:', error);
        throw error;
    }
};

export const getAReservationDetails = async bookid => {
    try {
        const res = await axiosPrivateInstance.get(
            `restaurant-table-reservation-detail/?id=${bookid}`
        );

        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const updateReservationStatus = async ({bookid, is_completed}) => {
    try {
        const res = await axiosPrivateInstance.patch(
            `restaurant-table-manual-confirm/?id=${bookid}&is_completed=${is_completed}`
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const getAllUpcomingDeliveries = async () => {
    try {
        const res = await axiosPrivateInstance.get(
            'upcoming-skipque-list/?ord_type=Delivery'
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const updateDeliverySettings = async ({ord_id, status}) => {
    try {
        const formData = new FormData();
        formData.append('ord_id', ord_id);
        formData.append('status', status);

        const res = await axiosPrivateInstance.patch(
            'upcoming-skipque-detail/',
            formData
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const filterDeliveryList = async status => {
    try {
        const res = await axiosPrivateInstance.get(
            `upcoming-skipque-list/?ord_type=Delivery&status=${status}`
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const getViewDeliveryDetails = async (
    ord_id,

) => {
    try {
        const res = await axiosPrivateInstance.get(
            `upcoming-skipque-detail/?ord_id=${ord_id}`
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const getAllUpcomingTakeaways = async () => {
    try {
        const res = await axiosPrivateInstance.get(
            `upcoming-skipque-list/?ord_type=Takeaway`
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const updateTakeawaySettings = async ({ord_id, status}) => {
    try {
        const formData = new FormData();
        formData.append('ord_id', ord_id);
        formData.append('status', status);

        const res = await axiosPrivateInstance.patch(
            'upcoming-skipque-detail/',
            formData
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const filterTakeawayList = async status => {
    try {
        const res = await axiosPrivateInstance.get(
            `upcoming-skipque-list/?ord_type=Takeaway&status=${status}`
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const getAllUpcomingCaterings = async () => {
    try {
        const res = await axiosPrivateInstance.get(`live-cater-requests/`);
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const filterCateringList = async status => {
    try {
        const res = await axiosPrivateInstance.get(
            `live-cater-requests/?serv_type=${status}`
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const updateCateringStatus = async ({eventid, status, custid}) => {
    console.log(eventid, status, custid);
    try {
        const formData = new FormData();
        formData.append('custid', custid);
        formData.append('eventid', eventid);
        formData.append('is_accept', status);

        const res = await axiosPrivateInstance.post('add-bid-chat/', formData);
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const getACateringDetails = async eventid => {
    try {
        const res = await axiosPrivateInstance.get(
            `live-cater-detail/?eventid=${eventid}`
        );
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const getAllReservations = async (
    page,
    pageItems = 10,
    fromDate = '',
    toDate = ''
) => {
    try {
        const res = await axiosPrivateInstance.get(
            `restaurant-table-reservation-history/?page=${page}&pageitems=${pageItems}&from_date=${fromDate}&to_date=${toDate}`
        );
        return res.data; // Return the full response object with pagination info
    } catch (error) {
        console.log('Error fetching reservations:', error);
        throw error;
    }
};

export const filterReservationHistory = async (
    status,
    page = 1,
    pageItems = 10,
    fromDate = '',
    toDate = ''
) => {
    try {
        // Build query parameters
        const params = new URLSearchParams({
            page: page.toString(),
            pageitems: pageItems.toString(),
        });

        // Add status filter if provided
        if (status && status !== 'All Status') {
            params.append('status', status);
        }

        // Add date filters if provided
        if (fromDate) {
            params.append('from_date', fromDate);
        }

        if (toDate) {
            params.append('to_date', toDate);
        }

        const res = await axiosPrivateInstance.get(
            `restaurant-table-reservation-history/?${params.toString()}`
        );

        return res.data; // Return the full response with pagination info
    } catch (error) {
        console.log('Error filtering reservations:', error);
        throw error;
    }
};

export const getAllDeliveries = async (
    page,
    pageItems = 10,
    fromDate = '',
    toDate = ''
) => {
    try {
        // Build query parameters
        const params = new URLSearchParams({
            page: page.toString(),
            pageitems: pageItems.toString(),
            ord_type: 'Delivery',
        });

        // Add date filters if provided
        if (fromDate) {
            params.append('from_date', fromDate);
        }

        if (toDate) {
            params.append('to_date', toDate);
        }

        const res = await axiosPrivateInstance.get(
            `restaurant-skipque-history/?${params.toString()}`
        );

        return res.data; // Return the full response object with pagination info
    } catch (error) {
        console.log('Error fetching deliveries:', error);
        throw error;
    }
};

export const filterDeliveryHistory = async (
    status,
    page = 1,
    pageItems = 10,
    fromDate = '',
    toDate = ''
) => {
    try {
        // Build query parameters
        const params = new URLSearchParams({
            page: page.toString(),
            pageitems: pageItems.toString(),
            ord_type: 'Delivery',
        });

        // Add status filter only if it's not empty (for 'all' case, don't include status)
        if (status && status !== 'all') {
            params.append('status', status);
        }

        // Add date filters if provided
        if (fromDate) {
            params.append('from_date', fromDate);
        }

        if (toDate) {
            params.append('to_date', toDate);
        }

        const res = await axiosPrivateInstance.get(
            `restaurant-skipque-history/?${params.toString()}`
        );

        return res.data; // Return the full response object with pagination info
    } catch (error) {
        console.log('Error fetching deliveries:', error);
        throw error;
    }
};

export const getAllTakeaways = async (
    page,
    pageItems = 10,
    fromDate = '',
    toDate = ''
) => {
    try {
        // Build query parameters
        const params = new URLSearchParams({
            page: page.toString(),
            pageitems: pageItems.toString(),
            ord_type: 'Takeaway',
        });

        // Add date filters if provided
        if (fromDate) {
            params.append('from_date', fromDate);
        }

        if (toDate) {
            params.append('to_date', toDate);
        }

        const res = await axiosPrivateInstance.get(
            `restaurant-skipque-history/?${params.toString()}`
        );

        return res.data; // Return the full response object with pagination info
    } catch (error) {
        console.log('Error fetching takeaways:', error);
        throw error;
    }
};

export const filterTakeawayHistory = async (
    status,
    page = 1,
    pageItems = 10,
    fromDate = '',
    toDate = ''
) => {
    try {
        // Build query parameters
        const params = new URLSearchParams({
            page: page.toString(),
            pageitems: pageItems.toString(),
            ord_type: 'Takeaway',
        });

        // Add status filter only if it's not empty (for 'all' case, don't include status)
        if (status && status !== 'all') {
            params.append('status', status);
        }

        // Add date filters if provided
        if (fromDate) {
            params.append('from_date', fromDate);
        }

        if (toDate) {
            params.append('to_date', toDate);
        }

        const res = await axiosPrivateInstance.get(
            `restaurant-skipque-history/?${params.toString()}`
        );

        return res.data; // Return the full response object with pagination info
    } catch (error) {
        console.log('Error fetching deliveries:', error);
        throw error;
    }
};

export const getAllCaterings = async (
    page,
    pageItems = 10,
    fromDate = '',
    toDate = ''
) => {
    try {
        // Build query parameters
        const params = new URLSearchParams({
            page: page.toString(),
            pageitems: pageItems.toString(),
        });

        // Add date filters if provided
        if (fromDate) {
            params.append('from_date', fromDate);
        }

        if (toDate) {
            params.append('to_date', toDate);
        }

        const res = await axiosPrivateInstance.get(
            `restaurant-caterevent-history/?${params.toString()}`
        );

        return res.data;
    } catch (error) {
        console.log(error);
    }
};

export const filterCateringHistory = async (
    status,
    page = 1,
    pageItems = 10,
    fromDate = '',
    toDate = ''
) => {
    try {
        // Build query parameters
        const params = new URLSearchParams({
            page: page.toString(),
            pageitems: pageItems.toString(),
        });

        // Add status filter only if it's not empty (for 'all' case, don't include status)
        if (status && status !== 'all') {
            params.append('status', status);
        }

        // Add date filters if provided
        if (fromDate) {
            params.append('from_date', fromDate);
        }

        if (toDate) {
            params.append('to_date', toDate);
        }

        const res = await axiosPrivateInstance.get(
            `restaurant-caterevent-history/?serv_type=inhome&${params.toString()}`
        );

        return res.data; // Return the full response object with pagination info
    } catch (error) {
        console.log('Error fetching catering list:', error);
        throw error;
    }
};
